// =====================================================================
// Assessment Center — Auth pages: shared shell.
// =====================================================================
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4 py-12 font-body">
      <div className="mb-6 w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-1 text-sm font-medium text-navy-700 hover:underline">
          <ArrowLeft size={15} /> Back
        </Link>
      </div>
      <div className="w-full max-w-md rounded-card border border-border-soft bg-white p-8 shadow-soft">
        <div className="mb-6">
          <h1 className="font-display text-2xl font-semibold tracking-tight text-navy-900">{title}</h1>
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
}
